import { render, staticRenderFns } from "./HotelFilters.vue?vue&type=template&id=20b5e648"
import script from "./HotelFilters.vue?vue&type=script&lang=js"
export * from "./HotelFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports